import React from "react";
import {
  UserOutlined,
  UnorderedListOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Login, OrderPage, ReportPage, RolePage, UserPage } from "../../pages";

export const routes = {
  login: "/",
  order: "/order",
  account: "/account",
  rol: "/rol",
  help: "/order",
  user: "/user",
  report: "/report",
};

export const AppPages = [
  { path: routes.login, protected: false, component: <Login /> },
  { path: routes.order, protected: true, component: <OrderPage /> },
  { path: routes.report, protected: true, component: <ReportPage /> },
  { path: routes.rol, protected: true, component: <RolePage /> },
  { path: routes.user, protected: true, component: <UserPage /> },
];

export const MenuItems: MenuProps["items"] = [
  {
    label: "Orders",
    key: routes.order,
    icon: <UnorderedListOutlined className="icon" />,
  },
  {
    label: "Reports",
    key: "reports",
    icon: <FileDoneOutlined className="icon" />,
    children: [
      {
        label: "Machinist Report",
        key: routes.report,
      },
    ],
  },
  {
    label: "Users",
    key: routes.user,
    icon: <UserOutlined className="icon" />,
  },
  { type: "divider" },
];
